import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';
import { Toaster } from 'sonner';
import { useT } from '@/shared/i18n/useT';
import { useTheme } from '@/shared/theme/useTheme';
import { Icon } from '../icons/Icon';
import { Spinner } from '../ui/Spinner';

const toastBase =
  'surface-float pointer-events-auto flex w-full items-start gap-3 rounded-lg px-4 py-3 text-sm text-fg sm:w-[22rem]';

/**
 * Toaster con los tokens de la app (sonner sin estilos propios). Arriba y centrado: no choca con la barra
 * inferior del móvil. Duración 4 s; las acciones llevan etiqueta de texto, no solo color.
 */
export function ToasterRoot() {
  const { resolved } = useTheme();
  const { t } = useT();
  return (
    <Toaster
      theme={resolved}
      position="top-center"
      duration={4000}
      visibleToasts={3}
      offset={{ top: 'calc(var(--safe-top) + 12px)', left: 16, right: 16 }}
      mobileOffset={{ top: 'calc(var(--safe-top) + 12px)', left: 16, right: 16 }}
      containerAriaLabel={t('aria.notifications')}
      icons={{
        success: <Icon icon={CircleCheck} className="text-up" />,
        error: <Icon icon={CircleAlert} className="text-down" />,
        warning: <Icon icon={TriangleAlert} className="text-warn" />,
        info: <Icon icon={Info} className="text-info" />,
        loading: <Spinner size={16} />,
      }}
      toastOptions={{
        unstyled: true,
        closeButtonAriaLabel: t('actions.close'),
        classNames: {
          toast: toastBase,
          content: 'min-w-0 flex-1',
          title: 'font-semibold text-fg',
          description: 'mt-0.5 text-fg-muted',
          icon: 'mt-0.5 shrink-0',
          actionButton:
            'ml-auto inline-flex h-9 shrink-0 items-center rounded-md bg-primary px-3 text-sm font-semibold text-primary-fg',
          cancelButton:
            'ml-auto inline-flex h-9 shrink-0 items-center rounded-md px-3 text-sm font-semibold text-fg-muted',
        },
      }}
    />
  );
}
